import React, { useState, useEffect } from 'react';
import { BackTop, Tabs, Skeleton } from 'antd';
import { useMappedState, useDispatch } from 'redux-react-hook';
import { getEvents } from './../API';
import EventsList from './../components/eventsList';
import EventsChart from './../components/eventsChart';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faChartBar } from '@fortawesome/free-solid-svg-icons'

const { TabPane } = Tabs;

const days = 30;

function Events() {
  const dispatch = useDispatch();
  const session = useMappedState(state => state.session);
  const events = useMappedState(state => state.events);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      const response = await getEvents(session.authToken, days);
      dispatch({type: "INIT_EVENTS", payload: response.data.events});
      setLoading(false);
    }
    dispatch({type: "SET_INDEX", payload: "6"});
    fetchData();
  // eslint-disable-next-line
  }, []);

  return (
    loading ?
    <div>
      <p>Loading...</p>
      <Skeleton active />
    </div>
    :
    <React.Fragment>
    <BackTop />
    <Tabs
      tabBarExtraContent={<div style={{color: '#408EBA', fontWeight: '500'}}>Last {days} days</div>}
      onChange={() => {}} 
      type="card"
    >
      <TabPane tab={
        <span><FontAwesomeIcon icon={faCalendarAlt} /> Active Events</span>
      } key="1">
        <EventsList data={events} />
      </TabPane>

      <TabPane tab={
        <span><FontAwesomeIcon icon={faChartBar} /> Chart</span>
      } key="2">
        <EventsChart data={events} days={days} />
      </TabPane>
    </Tabs>
    </React.Fragment>
  );
}

export default Events;
